import _ from 'lodash';
import { useHash } from '../../App';
import { key_pages } from '../enums/allPageTypes';
import { gEnums } from '../enums/globalEnums';
import { getViewSettingsBaseName, getViewSettingsKeys } from '../viewSettings/helpers/settingsHelpers';
import { dataModificationTypes } from '../viewSettings/enums/itemActionTypes';
import { _cacheNames } from '../cnr/reducers/ServiceWorkerReducer';
import { mobileDeviceTypes } from '../devices';

const isOdd = (num) => {
  return num % 2 === 1 ? true : false
}

// https://mobiledev.events.mywebsite.net/#/

export const currentHelpers = {
  convertPathToKeys: (pathName) => convertPathToKeys(pathName),
  extractFromUrl: (url) => extractFromUrl(url),
  getCurrent: (url, pathname) => getCurrent(url, pathname),
  getCurrentItem: (defaultItem, array) => getCurrentItem(defaultItem, array),
  getDevice: () => getDevice(),
  getHashPath: () => getHashPath(),
  getLastPathView: (pathName) => getLastPathView(pathName),
  getPathViews: (pathName) => getPathViews(pathName),
  getObjectPathView: (path) => getObjectPathView(path),
  getQueryParamsObject: () => getQueryParamsObject(),
  getTrueView: (pathViews, _view, trueView, landingView, _viewKey) => getTrueView(pathViews, _view, trueView, landingView, _viewKey),
  getQueryValues: (pathName) => getQueryValues(pathName),
  getSearchPath: (newPath, ddProps, ddn) => getSearchPath(newPath, ddProps, ddn),
  getSplits: () => getSplits(),
  getStorageItem: (itemKey, array, pathKey) => getStorageItem(itemKey, array, pathKey),
  pushBack: (navigate) => pushBack(navigate),
  removeParam: (param) => removeParam(param),
  storageItem_get: (storageKey) => storageItem_get(storageKey),
  storageItem_set: (storageKey, value) => storageItem_set(storageKey, value),
}

function extractFromUrl(url) {
  if (!url) return null;

  const clientIndex = url.lastIndexOf("clients/");
  const eventIndex = url.lastIndexOf("events/");

  if (clientIndex === -1) return null;

  const clientKey = url.substring(clientIndex + 8, url.indexOf("/", clientIndex + 8));
  const eventKey = eventIndex ? url.substring(eventIndex + 7, url.indexOf("/", eventIndex + 7)) : null;

  return {
    clientKey: clientKey || null,
    eventKey: eventKey || null
  };
}

const getObjectPathView = (path = "") => {
  if (!_.isString(path) || _.isEmpty(path)) return {};

  const parts = _.filter(_.split(_.trim(path, "/"), "/")); // remove empty or trailing segments
  if (parts.length % 2 !== 0) {
    console.warn("⚠️ Odd number of path segments — ignoring the last one:", path);
    parts.pop();
  }

  return _.fromPairs(_.chunk(parts, 2));
};


const getHashPath = () => {

  const { hash, origin, pathname, href } = window.location

  const qvs = href ? getQueryValues(href) : {}
  const svs = getQueryParamsObject()

  const queryValues = { ...qvs, ...svs }

  if (hash === '') {
    return {
      pathname,
      href,
      queryValues,
      _hash: useHash ? origin + '/#' + pathname : origin + pathname,
      _redirect: true,
      _pathName: useHash ? '/#' + pathname : pathname,
      _pathNameOriginal: pathname.substring(1)
    }
  } else {
    return { pathname, href, queryValues, _hash: hash, }
  }
}

const getSearchPath = (newPath, ddProps, ddn) => {
  let path = newPath + '?'
  if (ddProps) {
    Object.keys(ddProps).forEach(key => {
      path += key + '=' + ddProps[key]
    })
    path += '&' + ddn.key + '=' + ddn.value
  } else {
    path += ddn.key + '=' + ddn.value
  }
  return path
}

const getQueryParamsObject = () => {
  const hashParams = new URLSearchParams(window.location.hash.slice(1));
  return Object.fromEntries(hashParams.entries());
};

const getTrueView = (pathViews, _view, trueView, landingView, _viewKey) => {
  if (trueView === landingView) {
    if (pathViews?.events) {
      trueView = 'events'
    } else if (pathViews?.clients) {
      trueView = 'clients'
    }
  }
  return trueView
}

// eslint-disable-next-line 
const x = {
  event: {
    key: 'eventKey',
    attendees: {
      one: {
        test: 'test',
        aaaa: 'aaaa'
      },
      two: {
        test: 'test',
        aaaa: 'aaaa'
      }
    }
  }
}

const getLastPathView = (pathName) => {
  const pathViews = getPathViews(pathName)
  const lastPath = Object.keys(pathViews)[Object.keys(pathViews).length - 1]
  const pvs = pathName.split('/')
  return {
    path: lastPath,
    key: pathViews[lastPath],
    pathView: { [lastPath]: pathViews[lastPath] },
    lastKey: pvs[pvs.length - 1]
  }
}

const getSplits = () => {
  let splits = []
  try {
    splits = window.location.hash.split('/')
  } catch (error) {

  }
  return splits
}

export const getPathViews = (pathName) => {

  let counter = 1
  let start = 0
  let view = ''
  let hasDD = false
  let hasDDN = false

  const pathViews = {}

  const splitter = pathName.split('/')

  splitter.forEach((item, index) => {

    if (item === 'ddg') { hasDD = true }
    if (item === 'ddn') { hasDDN = true }

    if (index > start) {
      if (isOdd(counter)) {
        if (key_pages.includes(item)) {
        } else {
          if (!hasDD && !hasDDN) {
            view = item
          }
        }
      } else {
        if (!key_pages.includes(item) && !hasDD && !hasDDN) {
          pathViews[view] = item
        }
      }
      counter++
    }
  })

  return pathViews
}

const getQueryValues = (pathName) => {
  const queryValues = {};

  // Check if the URL contains a query string
  const queryString = pathName.split('?')[1];

  if (queryString) {
    // Split the query string into individual key-value pairs
    const keyValuePairs = queryString.split('&');

    keyValuePairs.forEach(pair => {
      const [key, value] = pair.split('=');

      if (key && value !== undefined) {
        // Decode URI components to handle special characters
        const decodedKey = decodeURIComponent(key);
        const decodedValue = decodeURIComponent(value);

        // Convert 'true' and 'false' strings to boolean values
        if (decodedValue === 'true') {
          queryValues[decodedKey] = true;
        } else if (decodedValue === 'false') {
          queryValues[decodedKey] = false;
        } else {
          queryValues[decodedKey] = decodedValue;
        }
      }
    });
  }

  return queryValues;
};

const getQueryValuesXXX = (pathName) => {
  const queryValues = {}
  const hashFragments = pathName.split('?')[1];
  if (hashFragments) {
    const _hashFragments = hashFragments.split('&')
    _hashFragments.forEach(hf => {
      const values = hf.split('=')
      if (values.length === 2) {
        if (values[1] === 'true') {
          queryValues[values[0]] = true
        } else if (values[1] === 'false') {
          queryValues[values[0]] = false
        } else {
          queryValues[values[0]] = values[1]
        }
      }
    })
  }
  return queryValues
}

const removeParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete(param);
  // Update the URL without the refresh query parameter
  const newUrlWithoutRefresh = window.location.pathname + '?' + urlParams.toString();
  return newUrlWithoutRefresh
};

const convertPathToKeys = (pathName) => {

  let counter = 1
  let start = 0
  let view = ''
  let viewKey = ''
  const pathViews = {}

  pathName.forEach((item, index) => {
    if (index > start) {
      if (isOdd(counter)) {
        view = item
        viewKey = null
      } else {
        viewKey = item
        pathViews[view] = viewKey
      }
      counter++
    }
  })

  return pathViews
}

/**
 * An object containing information about the current path.
 * @param props
 */
const getCurrent = (url, pathname) => {

  const hp = getHashPath()
  const { queryValues } = hp ?? {}
  const { appViewMode } = queryValues ?? {}

  let pathName = pathname ? pathname : url

  // trim pathName if last char is '/'
  if (pathName.substring(pathName.length - 1) === '/') {
    pathName = pathName.substring(0, pathName.length - 2)
  }

  const splitter = pathName.split('/')
  const pathViews = {}

  let hostName;

  if (useHash) {
    hostName = window && window.location ? window.location.hostname : ''
  } else {
    hostName = window && window.location ? window.location.hostname : ''
  }

  let counter = 1
  let dataMasked = false
  let lastPathName = splitter[splitter.length - 1]
  let lastView = ''
  let lastViewKey = ''
  let otherView = null
  let dataModificationView = null
  let start = 0
  let view = ''
  let viewKey = ''
  let ddGroupIndex = ''
  let ddGroupKey = ''

  const useLanding = true
  const landingView = 'landing'
  const landingViews = ['home', 'landing']
  const mainViews = ['home', 'clients', 'events']

  let hasDD = false
  let hasDDN = false

  splitter.forEach((item, index) => {

    if (item === 'mask') { dataMasked = true }
    if (item === 'ddg') { hasDD = true }
    if (item === 'ddn') { hasDDN = true }

    if (index > start) {
      if (isOdd(counter)) {
        if (dataModificationTypes[item]) {
          dataModificationView = item
        }
        if (key_pages.includes(item)) {
          otherView = item
        } else {
          if (!hasDD && !hasDDN) {
            view = item
            lastView = item
            viewKey = null
          }
        }
      } else {
        if (dataModificationTypes[item]) {
          dataModificationView = item
        }
        if (key_pages.includes(item)) {
          otherView = item
        } else {
          if (hasDD) {
            ddGroupIndex = parseInt(item)
          } else if (hasDDN) {
            ddGroupKey = item
          } else {
            viewKey = item
            lastViewKey = item
            pathViews[view] = viewKey ? viewKey.replace(/%20/g, ' ') : viewKey
          }
        }
      }
      counter++
    }
  })

  let storageRootPath = ''
  let rootPath = ''
  let pageKey = ''
  let rootPaths = {}
  let storagePaths = {}
  let lastRootPath = null

  Object.keys(pathViews).forEach(key => {
    const v = pathViews[key]
    storageRootPath = storageRootPath ? storageRootPath + '/' + key + '/' + v : key + '/' + v
    rootPath = rootPath + '/' + key + '/' + v
    pageKey = pageKey ? pageKey + '-' + v : v
    rootPaths[key] = rootPath + '/'
    const spz = rootPath
    storagePaths[key] = spz.substring(1)
    lastRootPath = rootPath
    if (!viewKey) { lastView = key }
  })

  if (dataMasked) {
    viewKey = null
    view = lastView
  }

  if (!view) { view = 'home' }

  let nonLandingView = view

  if (view === landingView && pathViews && Object.keys(pathViews).length > 0) {
    nonLandingView = Object.keys(pathViews)[Object.keys(pathViews).length - 1]
    viewKey = pathViews[nonLandingView]
  }

  if (useLanding) {
    if (landingViews.includes(viewKey)) {
      viewKey = landingView
    }
  }

  let trueView = view ? view : 'home'
  let appArea = gEnums.appAreaTypes.home

  if (view === 'clients') { appArea = gEnums.appAreaTypes.clients }
  if (rootPaths.clients) { appArea = gEnums.appAreaTypes.client }
  if (rootPaths.events) { appArea = gEnums.appAreaTypes.event }

  const { origin } = window.location
  let rp;

  switch (appArea) {
    case 'client':
      rp = rootPaths && rootPaths['clients'] ? rootPaths['clients'] : ''
      break;
    case 'event':
      rp = rootPaths && rootPaths['events'] ? rootPaths['events'] : ''
      break;
    default:
      break;
  }
  const sharePath = rp ? origin + '/#' + rp + 'landing' : origin + '/#/'
  const sharePathFull = origin + '/#' + pathName

  let ddProps = {}

  const pathModes = {
    attendees: pathViews.attendees ? true : false,
    demo: pathViews.demo ? true : false,
    district: pathViews && pathViews.districts && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    event: pathViews.events ? true : false,
    match: pathViews && pathViews.matches ? true : false,
    organization: pathViews && pathViews.organizations && !pathViews.districts ? true : false,
    school: pathViews.schools ? true : false,
    sessions: pathViews.sessions ? true : false,
    sport: pathViews && pathViews.sports ? true : false,
    team: pathViews.teams ? true : false,
  }

  const current = {
    _dataModifyType: dataModificationTypes[dataModificationView] ? dataModificationView : null,
    _isDataModify: dataModificationTypes[dataModificationView],
    appArea,
    appHome: 'home',
    appViewMode,
    dataMasked,
    dataModificationView,
    ddGroupIndex,
    ddGroupKey,
    ddProps: ddProps,
    eventPageKey: storageRootPath ? storageRootPath.replace(/\//g, '_') : null,
    fullSettingsKey: pathName.replace(/\//g, '_'),
    hostName,
    isHomePage: appArea === 'home',
    isLandingPage: landingView === view,
    landingView,
    lastPathName,
    lastRootPath,
    lastView,
    lastViewKey,
    mainViews,
    nonLandingView,
    otherView,
    pageKey,
    pathKey: pathName.replace(/\//g, '_'),
    pathModes,
    pathname,
    pathName,
    pathViews,
    queryValues,
    rootPath,
    rootPaths,
    screen: window.screen,
    settingsDocKeys: getViewSettingsKeys(view, pathViews),
    settingsDocName: getViewSettingsBaseName(view, pathViews),
    sharePath,
    sharePathFull,
    splitter,
    storageItemPage: viewKey ? view + '_' + viewKey : view,
    storageManifestPath: storageRootPath + '/manifest',
    storagePaths,
    storageRootPath,
    trueView,
    url,
    useLanding,
    view,
    viewAs: view,
    viewKey,
    viewPathKey: viewKey ? view + '-' + viewKey : view,
  }

  current.eventPath = rootPaths.events ? rootPath.replace(rootPaths.events, '') : ''
  current.eventPath = current.eventPath ? current.eventPath.replace('/', '_') : ''

  switch (view) {
    case 'home':
    case 'clients':
    case 'events':
      current.settingsDocDirect = true
      break;
    default:
      current.settingsDocDirect = false
      break;
  }


  let _cacheKey = '';

  switch (appArea) {
    case 'home':
      _cacheKey = _cacheNames.cache_home + '-' + current.settingsDocName
      break;
    case 'client':
      _cacheKey = _cacheNames.cache_client + '-' + current.settingsDocName
      break;
    case 'event':
      _cacheKey = _cacheNames.cache_event + '-' + current.settingsDocName
      break;
    default:
    // nothing
  }

  current.cacheKey = _cacheKey

  return current
}

const pushBack = (navigate) => {
  const { location } = navigate
  if (location && location.search) {
    navigate(-2)
  } else {
    storageItem_set('isBack', true)
    navigate(-1)
  }
}
const storageItem_set = (storageKey, value) => {
  window.localStorage.setItem(storageKey, value)
}

const storageItem_get = (storageKey) => {
  return window.localStorage.getItem(storageKey)
}

const getStorageItem = (itemKey, array, pathKey) => {
  const storageValue = window.localStorage.getItem(pathKey ? pathKey + '_' + itemKey : itemKey)
  if (storageValue) {
    return getCurrentItem(storageValue, array)
  } else {
    return getCurrentItem(array[0], array)
  }
}

const getCurrentItem = (defaultItem, array) => {
  const _array = array ? array : []
  const _defaultIndex = _array.indexOf(defaultItem)
  const _defaultValue = _defaultIndex && _defaultIndex > 0 ? _array[_defaultIndex] : _array[0]
  return { index: _defaultIndex, item: _defaultValue ? _defaultValue : {}, visible: false }
}

const getDevice = () => {
  return {
    android: /Android/i.test(navigator.userAgent),
    iphone: /iPhone|iphone/i.test(navigator.userAgent),
    ipad: /iPad|ipad/i.test(navigator.userAgent),
    ipod: /iPod|ipod/i.test(navigator.userAgent),
    userAgent: navigator.userAgent,
    name: gEnums.deviceNames.desktop
  }
}

const getAppDevice = (mobileDeviceTypes, value) => _.find(mobileDeviceTypes, { 'value': value })

export const getCurrentEnvironment = (appViewMode) => {

  const ua = navigator.userAgent;
  const uaLower = ua.toLowerCase();

  const isSafari = () => /version\/[\d.]+.*safari/i.test(ua);
  const isSmartphone = () =>
    /iphone|ipad|ipod|android|webos|blackberry|windows phone/i.test(uaLower) || isSafari();

  const isLaptop = () => {
    const isDesktop = !isSmartphone();
    const isMediumScreen = window.innerWidth > 768 && window.innerWidth <= 1440;
    return isDesktop && isMediumScreen;
  };

  const browser = {
    chrome: /chrome/i.test(ua) && !/edge|edg|opr/i.test(ua),
    firefox: /firefox/i.test(ua),
    safari: isSafari(),
    edge: /edge|edg/i.test(ua),
    opera: /opr/i.test(ua),
  };

  const device = {
    android: /android/i.test(ua),
    iphone: /iphone/i.test(ua),
    ipad: /ipad/i.test(ua),
    ipod: /ipod/i.test(ua),
    pixel: /pixel/i.test(ua),
  };

  // Determine device name (defaults to desktop)
  let deviceName = "desktop";
  if (device.android) deviceName = "android";
  else if (device.iphone) deviceName = "iphone";
  else if (device.ipad) deviceName = "ipad";
  else if (device.ipod) deviceName = "ipod";
  else if (device.pixel) deviceName = "pixel";

  // Determine browser name
  let browserName = "unknown";
  if (browser.chrome) browserName = "chrome";
  else if (browser.firefox) browserName = "firefox";
  else if (browser.safari) browserName = "safari";
  else if (browser.edge) browserName = "edge";
  else if (browser.opera) browserName = "opera";

  // Determine icon name
  let icon = "desktop";
  switch (browserName) {
    case "chrome":
    case "firefox":
    case "edge":
    case "opera":
      icon = browserName;
      break;
    default:
      icon = "desktop";
  }

  // Determine caption
  const deviceLabel = deviceName.charAt(0).toUpperCase() + deviceName.slice(1);
  const browserLabel = browserName.charAt(0).toUpperCase() + browserName.slice(1);
  const caption = `${deviceLabel} (${browserLabel})`;

  const _isLaptop = isLaptop()

  let fcmType;

  let osName = null;
  let osVersion = null;

  if (/android/i.test(ua)) {
    osName = "android";
    const match = ua.match(/Android\s+([\d._]+)/i);
    if (match && match[1]) osVersion = match[1]; // "14" or "13.1"
  } else if (/iphone|ipad|ipod/i.test(ua)) {
    osName = "iOS";
    // iOS version sometimes encoded like "OS 17_5"
    const match = ua.match(/OS\s+([\d_]+)/i);
    if (match && match[1]) osVersion = match[1].replace(/_/g, ".");
  }

  if (deviceName === 'desktop') {
    fcmType = browserName
  } else {
    fcmType = osName ? osName + '-' + osVersion : deviceName
  }

  const platform = {
    browser: browserName,
    name: browserName,
    icon,
    device: deviceName,
    caption,
    isMobileDevice: isSmartphone() || appViewMode === gEnums.appViewModes.googleSheets,
    isSmallScreen: window.innerWidth <= 768,
    isLaptop: _isLaptop,
    currentDevice: getDevice(),
    fcmType,
    isStandAlone:
      window.matchMedia('(display-mode: standalone)').matches ||
      navigator.standalone === true,
  }

  return {
    userAgent: ua,
    browser,
    device,
    platform,
    os: {
      name: osName,
      version: osVersion,
    }
  };
};
